import { requiredMessage, maxLength, minLength, pleaseEnterTheMessage } from "../utils/common";
var accountNumber = function accountNumber(value) {
  return !/^\d*$/.test(value);
};
var VARIANTS = {
  ARHI: "account number"
};
var VARIANT_REQUIRED_FUNCTION = {
  ARHI: requiredMessage,
  IAP: pleaseEnterTheMessage
};
var validAccountNumber = function validAccountNumber(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  if (!value) {
    var requiredFunction = VARIANT_REQUIRED_FUNCTION[funnel] || VARIANT_REQUIRED_FUNCTION.ARHI;
    error = requiredFunction(fieldName || VARIANTS[funnel] || VARIANTS.ARHI);
  } else if (accountNumber(value)) {
    error = "Your ".concat(fieldName || VARIANTS[funnel], " must only be digits.");
  } else if (maxLength(value)(9)) {
    error = "Your ".concat(fieldName || VARIANTS[funnel], " can have a maximum of 9 digits.");
  } else if (minLength(value)(3)) {
    error = "Your ".concat(fieldName || VARIANTS[funnel], " must be at least 3 digits.");
  }
  return error;
};
export default validAccountNumber;